/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * a set of APIs for copy and paste operations
 * @module CopyPasteAPI
 */
export default class CopyPasteAPI {
	constructor(copyImp, pasteImp) {
		/**
		 * To be invoked by the product only.
		 */
		this.destroy = function() {
			this.copy = () => {};
			this.paste = () => {};
		};

		/**
		 * Copy the currently displayed widget(s) in explore into clipboard
		 * @return {object} a promise which would be resolved when the action is done
		 */
		this.copy = copyImp;

		/**
		 * Paste the copied widget(s) to explore
		 * @return {object} a promise which would be resolved when the action is done
		 */
		this.paste = pasteImp;
	}
}



// WEBPACK FOOTER //
// ./src/js/api/CopyPasteAPI.js